import cn from "classnames";
import { Icon } from "@lynx/ui-components";

/**
 * Notice box: info | warning | error. `title` renders a bold first line with
 * an alert icon (the "Important information" variant).
 */
const PayoutNotice = ({ type = "info", title, children, className }) => (
  <div className={cn("payout-notice", `payout-notice-${type}`, className)} role="note">
    {title && (
      <div className="payout-notice-title">
        <Icon name="alert_triangle" />
        <span>{title}</span>
      </div>
    )}
    <div className="payout-notice-body">{children}</div>
  </div>
);

export default PayoutNotice;
